import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {MilestonePickerMilestone} from '@github-ui/item-picker-milestone-relay'
import {commitUpdateIssueMilestoneMutation as commitUpdateIssueMilestoneMutationFuture} from '@github-ui/item-picker-milestone-relay/commitUpdateIssueMilestoneMutation'
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  updateIssueMilestoneMutation,
  updateIssueMilestoneMutation$data,
} from './__generated__/updateIssueMilestoneMutation.graphql'

function commitUpdateIssueMilestoneMutationLegacy({
  environment,
  input: {issueId, milestone},
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {issueId: string; milestone: MilestonePickerMilestone | null}
  onError?: (error: Error) => void
  onCompleted?: (response: updateIssueMilestoneMutation$data) => void
}) {
  return commitMutation<updateIssueMilestoneMutation>(environment, {
    mutation: graphql`
      mutation updateIssueMilestoneMutation($input: UpdateIssueInput!) @raw_response_type {
        updateIssue(input: $input) {
          issue {
            id
            milestone {
              ...ItemPickerMilestoneRelayMilestone
            }
          }
        }
      }
    `,
    variables: {input: {id: issueId, milestoneId: milestone ? milestone.id : null}},
    optimisticResponse: {
      updateIssue: {
        issue: {
          id: issueId,
          milestone: milestone
            ? {
                id: milestone.id,
                title: milestone.title,
                closed: milestone.closed,
                dueOn: milestone.dueOn,
                progressPercentage: milestone.progressPercentage,
                url: milestone.url,
                closedAt: milestone.closedAt,
              }
            : null,
        },
      },
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}

export function commitUpdateIssueMilestoneMutation(props: {
  environment: Environment
  input: {issueId: string; milestone: MilestonePickerMilestone | null}
  onError?: (error: Error) => void
  onCompleted?: (response: updateIssueMilestoneMutation$data) => void
}) {
  return isFeatureEnabled('item_picker_mutations_relay_migration')
    ? commitUpdateIssueMilestoneMutationFuture(props)
    : commitUpdateIssueMilestoneMutationLegacy(props)
}
